exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Video--1y6ee9SKJLRl0hz8Dvs5TS {\n  width: 90px;\n  height: 20px;\n  color: #2c2a29;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-right: 12px;\n}\n\n.Video--2q5eWrxfZqGs3BMYdniVLS {\n  color: #2c2a29;\n  font-size: 18px;\n  text-align: right;\n}\n\n.Video--5HudNAmgGXDLhvOrtXg-_ {\n  display: inline-block;\n}\n\n.Video--5HudNAmgGXDLhvOrtXg-_ .Video--jUemTuqQq6cs9RW0VjPV0 {\n  display: inline-block;\n}\n\n.Video--5HudNAmgGXDLhvOrtXg-_ .Video--2XLbAt9KDCdEbVlYN4RV9u {\n  display: inline-block;\n  background: #eeeaf4;\n  height: 27px;\n  width: 27px;\n  border-radius: 50%;\n  color: #5b2f91;\n  font-size: 14px;\n  font-weight: normal;\n  text-align: center;\n  line-height: 27px;\n  margin-right: 8px;\n}\n\n.Video--1TiBq9zAa_M5tHR2RQgM9 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.Video--1TiBq9zAa_M5tHR2RQgM9.Video--bkjrb6xEK2jivMxNvkACC {\n  justify-content: flex-end;\n}\n\n.Video--10b98JEfKy2NT1Og5krgTJ {\n  display: flex;\n  align-items: center;\n}\n\n.Video--1-0r9EVfDw3Oo36tUutwOA {\n  color: #2c2a29;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.Video--3MDFji0zmO1204tv-Zwg-k {\n  margin-right: 8px;\n}\n\n.Video--3MDFji0zmO1204tv-Zwg-k a {\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.Video--NAFga_5XAOEush9qtqiWk {\n  color: #2c2a29;\n  font-size: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"participants": "Video--1y6ee9SKJLRl0hz8Dvs5TS",
	"participants": "Video--1y6ee9SKJLRl0hz8Dvs5TS",
	"notification": "Video--2q5eWrxfZqGs3BMYdniVLS",
	"notification": "Video--2q5eWrxfZqGs3BMYdniVLS",
	"attendees": "Video--5HudNAmgGXDLhvOrtXg-_",
	"attendees": "Video--5HudNAmgGXDLhvOrtXg-_",
	"list": "Video--jUemTuqQq6cs9RW0VjPV0",
	"list": "Video--jUemTuqQq6cs9RW0VjPV0",
	"attende": "Video--2XLbAt9KDCdEbVlYN4RV9u",
	"attende": "Video--2XLbAt9KDCdEbVlYN4RV9u",
	"row": "Video--1TiBq9zAa_M5tHR2RQgM9",
	"row": "Video--1TiBq9zAa_M5tHR2RQgM9",
	"right": "Video--bkjrb6xEK2jivMxNvkACC",
	"right": "Video--bkjrb6xEK2jivMxNvkACC",
	"call": "Video--10b98JEfKy2NT1Og5krgTJ",
	"call": "Video--10b98JEfKy2NT1Og5krgTJ",
	"link": "Video--1-0r9EVfDw3Oo36tUutwOA",
	"link": "Video--1-0r9EVfDw3Oo36tUutwOA",
	"link_space": "Video--3MDFji0zmO1204tv-Zwg-k",
	"linkSpace": "Video--3MDFji0zmO1204tv-Zwg-k",
	"text": "Video--NAFga_5XAOEush9qtqiWk",
	"text": "Video--NAFga_5XAOEush9qtqiWk"
};